
import { generateQueryParams } from 'utils/interfaces';
import CommonService from './common.service';

class BannerService extends CommonService {
	async getBanners(params?: { [key: string]: string | boolean }) {
		const query = generateQueryParams(params);
		return await this.get(`banners/?${query}`);
	}
	async getBannerDetails(id: string) {
		return await this.get(`banners/${id}`)
	}
	async createBanner(parmas: { [key: string]: boolean | string }) {
		return await this.post('banners', parmas)
	}
	async updateBanner(id: string, params: { [key: string]: boolean | string }) {
		return await this.put(`banners/${id}`, params)
	}
	async deleteBanners(id: string) {
		return await this.delete(`banners/${id}`)
	}
	
}
export const bannerService = new BannerService();
